import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=7b4048a6&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=7b4048a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4048a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2Announcement: require('/app/components/Theme2/Announcement.vue').default,Theme2DesktopLotteryWinners: require('/app/components/Theme2/Desktop/LotteryWinners.vue').default,Theme2DesktopTopDepositRanking: require('/app/components/Theme2/Desktop/TopDepositRanking.vue').default,Theme2MobileFooterImageMobile: require('/app/components/Theme2/Mobile/FooterImageMobile.vue').default,CommonsPopup: require('/app/components/Commons/Popup.vue').default})
